import SharePage from '../../modules/shareResult/index'
export default SharePage